/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
	import RovoExtensionInstallCtaLeftNav from '@post-office/message-template--rovo-extension-install-cta-left-nav/placements/in-app/jira-side-nav/render';

export default {
	'rovo-extension-install-cta-left-nav': RovoExtensionInstallCtaLeftNav,
};
